import { Phone } from "lucide-react";

interface StickyCallBarProps {
  phoneNumber?: string;
}

const StickyCallBar = ({ phoneNumber = "(214) 646-3802" }: StickyCallBarProps) => {
  const telNumber = phoneNumber.replace(/[\s()-]/g, "");

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-gold shadow-[0_-4px_12px_rgba(0,0,0,0.15)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={`tel:${telNumber}`}
        aria-label={`Call ${phoneNumber}`}
        className="flex items-center justify-center gap-3 min-h-[56px] px-4 text-navy-dark font-bold text-base active:bg-gold-dark transition-colors"
      >
        <Phone className="w-5 h-5 animate-pulse" aria-hidden="true" />
        <span>Call Now: {phoneNumber}</span>
      </a>
    </div>
  );
};

export default StickyCallBar;
